import React from 'react'
import Arrow from './Arrow'
import withContainer from '../../HOCs/withContainer'
import {Button} from 'reactstrap'

const StepTourContent = ({
    placement,
    title,
    description,
    index,
    totalStep,
    onClose,
    onNext,
    onFinish,
    nextBtnProps,
    closeBtnProps,
    arrowProps,
}) => {
    const isLast = index === totalStep - 1

    const isFirst = index === 0

    return (
        <div>
            <Arrow placement={placement} {...arrowProps} />

            {title && <div className={'StepTourContent__Title'}>{title}</div>}
            <div className={'StepTourContent__Description'}>
                {description}
                {!isFirst && (
                    <div className={'StepTourContent__Counter'}>
                        <span className={'text-primary'}>{index}</span> of {totalStep - 1}
                    </div>
                )}
            </div>
            <div
                className={'list w-100'}
                style={{
                    '--direction': 'row',
                    '--gap': '8px',
                }}
            >
                {isLast ? (
                    <Button color={'primary'} onClick={onFinish} className={'w-100'}>
                        Finish tour
                    </Button>
                ) : (
                    <>
                        <Button
                            color={'secondary'}
                            className={'StepTourContent__CloseButton w-100'}
                            onClick={isFirst ? onFinish : onClose}
                            {...closeBtnProps}
                        >
                            {isFirst ? 'Explore by myself' : 'Close'}
                        </Button>

                        <Button color={'primary'} onClick={onNext} className={'w-100'} {...nextBtnProps}>
                            {nextBtnProps?.children ? nextBtnProps?.children : isFirst ? 'Start the tour' : 'Next'}
                        </Button>
                    </>
                )}
            </div>
        </div>
    )
}
export default withContainer(StepTourContent)
